import * as React from "react";
import { Box, Button, Dialog, DialogContent, Grid, Tab, Tabs } from "@material-ui/core";

import { IQuiltParams } from "Model/IQuiltParams";
import { IColorPalette } from "Model/IColorPalette";
import { IBlockQuiltParams } from "Model/IBlockQuiltParams";
import { IGeneralQuiltParams } from "Model/IGeneralQuiltParams";

import { QuiltParamsHelper } from "Utility/QuiltParamsHelper";

import { ColorEditor } from "./ColorEditor";
import { BlockEditor } from "./BlockEditor";
import { GeneralEditor } from "./GeneralEditor";

export interface IProps {
    readonly quiltParams: IQuiltParams;
    readonly palettes: IColorPalette[];

    readonly onClose: () => void;
    readonly setParams: (p: IQuiltParams) => void;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
  }
  
function TabPanel(props: TabPanelProps) {
    const { children, value, index } = props;
  
    return (
      <div role="tabpanel" hidden={value !== index}>
        {value === index && (
          <Box p={1}>
            {children}
          </Box>
        )}
      </div>
    );
  }

export function SettingsDialog(props: IProps): React.ReactElement {
    const params = props.quiltParams;

    const [resetCount, setResetCount] = React.useState(0);

    const onGeneralParamsChanged = (p: IGeneralQuiltParams) =>
        props.setParams(QuiltParamsHelper.setGeneralParams(params, p));

    const onBlockParamsChanged = (p: IBlockQuiltParams) =>
        props.setParams(QuiltParamsHelper.setBlockParams(params, p));

    const onReset = () => {
        if (resetCount === 0) {
            setResetCount(1);
        } else {
            props.setParams(QuiltParamsHelper.makeDefault(params.general.version));
            setResetCount(0);
        }
    }

    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => 
        setValue(newValue);

    return (
        <Dialog onClose={props.onClose} open>
            <DialogContent>
                <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary">
                    <Tab label="General"/>
                    <Tab label="Block"/>
                    <Tab label="Color"/>
                </Tabs>
                <TabPanel value={value} index={0}>
                    <GeneralEditor params={params.general} onChanged={onGeneralParamsChanged} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <BlockEditor params={params.block} onChanged={onBlockParamsChanged} />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <ColorEditor
                        params={params}
                        palettes={props.palettes}
                        onGeneralParamsChanged={onGeneralParamsChanged}
                        onBlockParamsChanged={onBlockParamsChanged} />
                </TabPanel>
                <Grid container direction="row" justify="center" alignItems="center">
                    <Grid item>
                        <Button variant="contained" color={resetCount === 1 ? "secondary" : undefined} onClick={onReset}>Reset to defaults</Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>

    )
}